import { Pipe, PipeTransform } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
/*
 * Adds a dash between the sixth and seventh digits of the CPR number
 */
@Pipe({ name: "translateOptionsArray" })
export class TranslateOptionsArray implements PipeTransform {
  constructor(private translate: TranslateService) {}
  transform(
    value: { id: string; i18n: string }[]
  ): { id: string; i18n: string; label: string }[] {
    return value.map(option => {
      return { label: this.translate.instant(option.i18n), ...option };
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pipes/translate-options-array.ts